module.exports = __webpack_public_path__ + "images/ai_recommendations/translate-fa328e351c0ff17865049ad37fbaca40.svg";